import { Logger, LogLevel } from '@hec/models';

export class LogHandler {
  static handle(logger: Logger, logLevel: LogLevel, error: Error) {
    logger.error(error.message, error);
  }
}
